enum ENotifyVariant {
  INFO = 'info',
  ERROR = 'error',
}

export default ENotifyVariant;
